import styles from "./PreviewSection.module.scss";

const PreviewSection = (props) => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>{props?.data?.value || props?.name}</span>
        </div>
      </div>
    </div>
  );
};

export default PreviewSection;
